import React from 'react';

import {
  CarRegularIcon,
  CarsSolidIcon,
  LyftBrandsIcon,
  RouteHighwayRegularIcon,
  ScribbleRegularIcon,
  TrafficLightRegularIcon,
  TruckRampCouchRegularIcon
} from '../../shared/icons/icons';

interface TreadwellPersonaIconProps {
  className?: String;
  iconName?: String | null;
}

function TreadwellPersonaIcon(props: TreadwellPersonaIconProps) {
  const { className, iconName } = props;

  let Icon;
  switch (iconName) {
    case 'CarRegularIcon':
      Icon = CarRegularIcon;
      break;
    case 'CarsSolidIcon':
      Icon = CarsSolidIcon;
      break;
    case 'LyftBrandsIcon':
      Icon = LyftBrandsIcon;
      break;
    case 'RouteHighwayRegularIcon':
      Icon = RouteHighwayRegularIcon;
      break;
    case 'ScribbleRegularIcon':
      Icon = ScribbleRegularIcon;
      break;
    case 'TruckRampCouchRegularIcon':
      Icon = TruckRampCouchRegularIcon;
      break;
    case 'TrafficLightRegularIcon':
      Icon = TrafficLightRegularIcon;
      break;
    default:
      Icon = TrafficLightRegularIcon;
      break;
  }

  return <Icon className={className} />;
}

export default TreadwellPersonaIcon;
